// extracted by mini-css-extract-plugin
module.exports = {"stack":"EquipmentCompactCell_stack__OTd_o","trailerTypes":"EquipmentCompactCell_trailerTypes__Th7gz","dimensions":"EquipmentCompactCell_dimensions___neeS"};